import { Component, inject } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Store } from '@ngrx/store';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import moment from 'moment';

import { Fa6Module } from '@proman/fa/fa6.module';
import { PipesModule } from '@proman/shared/pipes/pipes.module';

import { Entity } from '@proman/services/entity.service';
import { AiFriendService } from '@proman/services/ai-friend.service';

import { isDefinedNotNull } from '@proman/utils';
import { getCurrUser } from '@proman/store/curr-user';

import { AiConversationMessage, CurrUser } from '@proman/interfaces/object-interfaces';

import { PromanPaddingDirective } from '@proman/shared/directives/proman-padding.directive';

import { PromanButtonComponent } from '@proman/button';
import { PromanTextSimpleComponent } from '@proman/text-simple';

@Component({
  imports: [
    FlexLayoutModule,
    Fa6Module,
    PipesModule,

    PromanPaddingDirective,
    PromanButtonComponent,
    PromanTextSimpleComponent,
  ],
  template: `
    <div>
      <div proPadding class="message-container" fxLayout="column">
        @for (message of messageHistory; track $index) {
          <article fxLayout="row" fxLayoutAlign="start center">
            <div fxLayout="column" fxLayoutAlign="center center">
              <fa [name]="message.personId ? 'user' : 'brain-circuit'"></fa>
              <div [innerHTML]="message.timestamp"></div>
            </div>
            <p fxFlex="80" proPadding [innerHTML]="message.message"></p>
          </article>
        }
      </div>

      @if (checkPerson()) {
        <div proPadding fxLayout="row">
          <pro-text-simple [value]="prompt" [config]="{ label: 'prompt', type: 'textarea' }"
                           (onChange)="setPrompt($event)"></pro-text-simple>
          <pro-btn icon="message-question" theme="accent" [disabled]="!prompt" (onClick)="sendPrompt()"></pro-btn>
        </div>
      }
    </div>
  `,
  styles: `
      .message-container {
          overflow-y: scroll;
      }
  `
})

export class AiFriendConversationComponent {
  AiFriend = inject(AiFriendService);
  Entity = inject(Entity);
  store = inject(Store);

  sortSheet = inject(MatBottomSheet);
  sortSheetRef = inject(MatBottomSheetRef<AiFriendConversationComponent>);

  messageHistory: AiConversationMessage[] = [];
  conversation: any;
  currUser: CurrUser;
  prompt: string;

  constructor() {
    this.store.select(getCurrUser).subscribe((value) => this.currUser = value);
    const id = this.AiFriend.selectedConversation();
    if (id) {
      this.Entity.get('ai_conversation').get({ id, partialJoin: { 'createdBy': ['id', 'name']} }).then((conversation) => {
        this.conversation = conversation;
        this.AiFriend.authorId = conversation.createdBy.id;
        this.messageHistory = conversation.conversation
          .map((msg: AiConversationMessage) =>
            ({ ...msg, timestamp: moment.unix(+msg.timestamp).format('YYYY-MM-DD HH:mm:ss')
                .replace(' ', '<br>') }))
          .map((msg: AiConversationMessage) => {
            msg.message = msg.message.replace(/\n/g, '<br>')
              .replace(/\*\*\s/g, '</b> ').replace(/\*\*/g, '<b>');
            return msg;
        });
        console.log(conversation);
      });
    } else {
      this.AiFriend.authorId = this.currUser.person.id
      this.conversation = null;
      this.messageHistory = [];
    }
  }

  setPrompt = (value: string) => this.prompt = value;

  checkPerson = () => this.AiFriend.checkPerson();

  sendPrompt() {
    if (isDefinedNotNull(this.prompt)) {
      this.messageHistory.push({ personId: this.currUser.person.id, message: this.prompt });
      this.AiFriend.askFriend(this.prompt, this.AiFriend.selectedConversation() !== -1 ? this.AiFriend.selectedConversation() : undefined)
        .then((result: { answer: string, id: number }) => {
          this.AiFriend.selectedConversation.set(result.id);
          let answer = result.answer;
          answer = answer.replace(/\n/g, '<br>');
          answer = answer.replace(/\*\*\s/g, '</b> ');
          answer = answer.replace(/\*\*/g, '<b>');
          this.prompt = null;
          this.messageHistory.push({ personId: 0, message: answer });
      });
    }
  }

}